import axiosInstance from "../service/api_service.js";
import ApiRoutes from "../utils/api_routes.js";

export const addAttendanceLog = async (data) => {
  try {
    console.log(JSON.stringify(data));

    const response = await axiosInstance.post(ApiRoutes.addAttendance, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getMyAttendanceLogs = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getAttendance);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getCompanyHolidays = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.holidayList);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getCompanyTomarrowHoliday = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.holidaytomarrow);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addTodayAttendance = async (data = {}) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.todayAttendance, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};



